import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import jwt_decode from 'jwt-decode';
import { FullUserData } from 'src/app/Modules/management/models/organization/fullUserData.model';
import { ManagementApiService } from 'src/app/services';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { CustomValidatorService } from 'src/app/services/custom-validator.service';

@Component({
    selector: 'app-user-personal-details',
    templateUrl: './user-personal-details.component.html',
    styleUrls: ['./user-personal-details.component.scss'],
    standalone: false
})
export class UserPersonalDetailsComponent implements OnInit {
    @Input() form: UntypedFormGroup;
    @Output() viewImg: EventEmitter<string> = new EventEmitter();

    UserData: FullUserData;
    userFormData: FormData;
    isTelephoneChanged: boolean;
    isProImgChanged: boolean;
    url: any;
    selectedFile: File;
    proImg: string;
    isEditable: boolean;
    isfedrated: boolean;
    filterLanguage: any = [];
    languageSettingValueId: string;
    selectedLanguage: string;
    isLanguageChanged: boolean;
    decodedToken: any;
    language = ['English', 'French', 'Portugese', 'Chinese'];

    constructor(
        private globalEmittersService: GlobalEmittersService,
        private user_utility: UserUtilityService,
        private managementApiService: ManagementApiService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private customToastServiceService: CustomToastService,
        private customValidator: CustomValidatorService
    ) {}

    async ngOnInit() {
        this.getAndSetUserDetails();
        this.isEditable = await this.user_utility.checkUserPermissionDataAndRoute('profile-personal-setting', userActions.Edit);

        this.globalEmittersService.savePersonalDetails.subscribe((res) => {
            this.saveUserProfile();
        });
    }

    async getAndSetUserDetails() {
        this.UserData = this.user_utility.userData;
        this.isfedrated = this.user_utility.userData.organisation.isFederated;
        this.proImg = this.user_utility.userData.profileImage;
        let languageSetting = this.UserData?.settings.find((x) => x.setting.key == 'DefaultLanguage');
        this.filterLanguage = languageSetting.setting.settingValues.filter((s) => this.language.includes(s.value));
        await this.initFormGroup();
    }

    async initFormGroup() {
        // this.form.get('personalDetails') as
        this.form.addControl(
            'personalDetails',
            new UntypedFormGroup({
                first_name: new UntypedFormControl(this.UserData?.profileContact?.firstName, [Validators.max(255)]),
                last_name: new UntypedFormControl(this.UserData?.profileContact?.lastName, [Validators.max(255)]),
                organization_name: new UntypedFormControl(this.UserData?.organisation?.name, [Validators.max(255)]),
                telephone: new UntypedFormControl(this.UserData?.profileContact?.telephone, [Validators.pattern('^[0-9()+\-]*$')]),
                email: new UntypedFormControl(this.UserData?.profileContact?.email, [Validators.max(255)]),
                security_role: new UntypedFormControl(this.UserData?.securityRoles[0]?.securityRole.name, [Validators.max(255)]),
                default_language: new UntypedFormControl(this.UserData?.settings[0]?.settingValue?.settingValueId),
            })
        );

        if (this.UserData.license.endDate) {
            let resp = this.form.get('personalDetails') as UntypedFormGroup;
            resp.addControl('licence_end_date', new UntypedFormControl(this.UserData?.license.endDate));
        }

        this.form
            .get('personalDetails')
            .get('default_language')
            .valueChanges.subscribe((res) => {
                this.isLanguageChanged = true;
                this.languageSettingValueId = res;
                this.selectedLanguage = this.UserData.settings[0].setting.settingValues.find((s) => s.settingValueId == this.languageSettingValueId).value;
            });
    }
    onSelectFile(event) {
        const reader = new FileReader();
        if (event.target.files && event.target.files.length) {
            const [file] = event.target.files;

            reader.readAsDataURL(file);
            reader.onload = () => {
                this.url = document.querySelector('.profile_image_organization');
                this.isProImgChanged = true;
                this.url.src = reader.result;
                this.proImg = this.url.src;
                this.selectedFile = file;
                this.viewImg.emit(this.url.src);
                this.form.patchValue({
                    profileImage: reader.result,
                });
                this.form.get('profileImage').markAsDirty();
            };
        }
    }

    createUserObject() {
        let newObj: any = {};
        newObj.userId = this.UserData.userId;
        newObj.profileContact = this.UserData.profileContact;
        this.UserData.profileContact.telephone = this.form.get('personalDetails').get('telephone').value;
        newObj.profileContact.telephone = this.form.get('personalDetails').get('telephone').value;
        newObj.profileContact.firstName = this.form.get('personalDetails').get('first_name').value;
        newObj.profileContact.lastName = this.form.get('personalDetails').get('last_name').value;

        if (this.isLanguageChanged) {
            let settings: any = {};
            settings.UserSettingId =
                this.UserData.settings[0].userSettingId != this.user_utility.userData.settings[0].userSettingId
                    ? this.user_utility.userData.settings[0].userSettingId
                    : this.UserData.settings[0].userSettingId;
            settings.SettingId = this.UserData.settings[0].setting.settingId;
            settings.userId = this.UserData.settings[0].userId;
            settings.SettingValueId = this.languageSettingValueId;

            newObj.settings = [settings];
        }

        return newObj;
    }

    async saveUserProfile() {
        //Doing Api Call for profile tab

        let payload = this.createUserObject();
        this.ngxUiLoaderService.start();
        this.managementApiService.updateCurrentUser(payload).subscribe(
            async (response) => {
                if (response.success === true) {
                    this.form.markAsPristine();
                    this.customToastServiceService.successToast('User updated successfully', 'Success');
                    this.user_utility.refreshProfileData();
                    this.getAndSetUserDetails();
                     await this.managementApiService.postLogin();
                } else {
                    this.customToastServiceService.errorToast(response.message);
                }
                this.ngxUiLoaderService.stop();
            },
            (error) => {
                this.ngxUiLoaderService.stop();
                //here toastr will be added
            }
        );
    }

    getDecodedAccessToken(token: string): any {
        try {
            return jwt_decode(token);
        } catch (Error) {
            return null;
        }
    }

    numberOnly(event: KeyboardEvent): boolean {
        const allowedChars = /[0-9+\-()]/;
        const inputChar = String.fromCharCode(event.keyCode || event.which);

        if (!allowedChars.test(inputChar)) {
            event.preventDefault();
            return false;
        }
        return true;
    }

    validatePaste(event: ClipboardEvent) {
        const clipboardData = event.clipboardData?.getData('text') || '';
        const allowedPattern = /^[0-9+\-()]*$/;
        if (!allowedPattern.test(clipboardData)) {
            event.preventDefault();
        }
    }

    onKeyPress(event: KeyboardEvent) {
        this.customValidator.validateKeyPress(event);
    }
}
